<template>
    <div class="container page">
        <van-nav-bar title="明細" class="nav-bar">
            <template #left>
                <van-icon name="arrow-left" color="#fff" @click="back()" />
            </template>
        </van-nav-bar>
        <div class="detail-container">
            <div v-for="item in dataList"  :key="item.id" class="detail-item">
                <van-row >
                    <van-col span="12">
                        <span class="title-label">
                            期號: 
                        </span>
                        <span class="info">
                            {{item.expect}}
                        </span>
                    </van-col>
                    <van-col span="12">
                        <span class="title-label">
                            盈虧: 
                        </span>
                        <span class="info">
                            {{item.win_text}}
                        </span>
                    </van-col>
                    <van-col span="12">
                        <span class="title-label">
                            投注金額: 
                        </span>
                        <span class="info">
                            {{item.money}}
                        </span>
                    </van-col>
                    <van-col span="12">
                        <span class="title-label">
                            盈利: 
                        </span>
                        <span class="info">
                            {{item.is_win===2?0: item.profit}}
                        </span>
                    </van-col>
                    <van-col span="12">
                        <span class="title-label">
                            類型: 
                        </span>
                        <span class="info">
                            {{item.status_text}}
                        </span>
                    </van-col>
                    <van-col span="24">
                        <span class="title-label">
                            下單時間: 
                        </span>
                        <span class="info">
                            {{item.create_time}}
                        </span>
                    </van-col>
                </van-row>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            dataList: []
        };
    },
    methods: {
        back() {
            return window.history.back();
        },
    },
    created(){
        if(this.$route.query.data){
            this.dataList = JSON.parse( this.$route.query.data);
        }
        console.log('111',this.$route.query);

        console.log('111',JSON.parse( this.$route.query.data));
    }
}

</script>

<style lang='less' scoped>
.detail-container{
    padding: 10px;
    .detail-item{
        padding: 10px;
        background-color: #fff;
        margin-bottom: 20px;
        border-radius: 10px;
        .title-label{
            color: #c24491;
            font-weight: 500;

        }
        .info{
            color: #333;
            font-size: 28px;
        }
        ::v-deep .van-col{
            margin-bottom: 8px;
        }
    }
}
</style>